<div class="upload-file-wrapper" *ngIf="showUploadFileWindow">
    <div class="upload-file-frame">
        <div class="special-title">שים לב</div>
        <div class="close-upload" (click)="approve()">
            <div>X</div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">

                    <div class="upload-file-title-error">
                        הקבצים שהעלת נמחקו לאחר רענון הדף. אנא העלה אותם שוב
                    </div>
                    <div class="upload-file-prod-row" *ngFor="let item of clientTransactionItems; let i=index">
                        <div class="prod-name"> {{item.ProdName}}</div>
                        <div class="pic-list-wrapper">


                            <div class="pic-list" *ngFor="let file of files[i]; let fileIndex=index">

                                <div class="remove-pic remove-file-item" (click)="removeFile(fileIndex, i)">X</div>

                                <div class="detail-text-images">
                                    <div class="file-img-wrapper">
                                        <div class="file-img">
                                            <img *ngIf="getFileExtension(i, fileIndex)!='dwg' && 
                                            getFileExtension(i, fileIndex)!='pdf' && getFileExtension(i, fileIndex)!='zip' 
                                             && getFileExtension(i, fileIndex)!='rar'" src="{{filesSrcBase64[i][fileIndex]}}" />
                                            <div class="dwg-pic" *ngIf="getFileExtension(i, fileIndex)=='dwg'"></div>
                                            <div class="pdf-pic" *ngIf="getFileExtension(i, fileIndex)=='pdf'">
                                                <fa-icon [icon]="['far', 'file-pdf']"></fa-icon>
                                            </div>
                                            <div class="pdf-pic" *ngIf="getFileExtension(i, fileIndex)=='zip' || getFileExtension(i, fileIndex)=='rar'">
                                                <fa-icon [icon]="['far', 'file-pdf']"></fa-icon>
                                            </div>
                                        </div>

                                        <div class="img-caption">
                                            {{file.name}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-pic-wrapper">
                            <div class="btn add-pic pay-btn" (click)="selectFile(i)">
                                בחר קבצים
                            </div>
                        </div>
                    </div>
                    <div class="alert-danger file-error" *ngIf="displayError">הקובץ שהעלאת ({{this.errorFileName}}) לא תקין ולכן לא יישלח</div>
                    <div class="alert-danger file-error" *ngIf="displayErrorSize">נפח הקבצים שהעלאת גדול מידי. מקסימום {{maxFilesSizeCombined/1000000}}MB</div>

                    <div class="btn aprove pay-btn" (click)="approve()">אישור</div>
                </div>
            </div>
        </div>

    </div>
</div>
<input *ngIf="renderFileIpload" type="file" id="upload-file-list" multiple value="files" (change)="upload($event)" placeholder="העלה קובץ" />